import apiClient from './apiClient'

const getNotes = (tenant, projectId) => {
  return apiClient.get(`/${tenant}/Note/${projectId}`)
}

const getNoteById = (tenant, params) => {
  return apiClient.get(`/${tenant}/Note/${params.projectId}/${params.id}`)
}

const createNote = (tenant, params) => {
  // params = {
  //   "projectId": "string",
  //   "title": "string",
  //   "text": "string"
  // }
  return apiClient.post(`/${tenant}/Note/${params.projectId}`, params)
}

const updateNote = (tenant, params) => {
  // params = {
  //   "projectId": "string",
  //   "id": "string",
  //   "title": "string",
  //   "text": "string"
  // }
  return apiClient.put(`/${tenant}/Note/${params.projectId}/${params.id}`, params)
}

const deleteNote = (tenant, params) => {
  // params = {
  //   "projectId": "string",
  //   "id": "string",
  // }
  return apiClient.delete(`/${tenant}/Note/${params.projectId}/${params.id}`)
}


export default {
  getNotes,
  getNoteById,
  createNote,
  updateNote,
  deleteNote
}
